<template>
  <div class="row justify-content-md-center">
    <div class="col-12">
           <h2 class="section__title  mb-5">Account Settings</h2>
    </div>
    <div class="col-12">
      <flash message="" class="mb-4 pl-4"></flash>
      <div class="card border-0 card border-0 p-4 p-md-5">
        <form>
          <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Customer ID / Username</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" :value="account.customer_id">
            </div>
            <div class="col-sm-3 text-center text-md-left">
              <a class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0" data-toggle="modal" data-target="#changePasswordModal">Change Password</a>
            </div>
          </div>
          <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Email Address</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" :value="account.email">
            </div>
            <div class="col-sm-3  text-center text-md-left">
              <a class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0" data-toggle="modal" data-target="#changeEmailModal">Change Email Address</a>
            </div>
          </div>
          <!-- <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Password</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" value="**********">
            </div>
            <div class="col-sm-3 text-center text-md-left">
              <a class="btn --theme-primary --style-long --style-xsmall mt-3 mt-md-0" data-toggle="modal" data-target="#changePasswordModal">Change Password</a>
            </div>
          </div> -->
         <!--  <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Account Expiry</b></label>
            <div class="col-sm-6">
              <input v-if="account.premium_until && account.premium_until < 2145916800" type="text" readonly class="form-control form-control-lg" :value="account.premium_until | moment">
               <input v-else-if="account.premium_until && account.premium_until >= 2145916800" type="text" readonly class="form-control form-control-lg" value="N/A">
              <input v-else type="text" readonly class="form-control form-control-lg" value="Not Premium">
            </div>
             <div class="col-sm-3  text-center text-md-left">
              <a class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0" href="/premium">Buy Membership</a>
            </div>
          </div> -->
          <!-- <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Secure Download</b></label>
            <div class="col-sm-6">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline1" name="secure_download" class="custom-control-input" checked="checked">
                <label class="custom-control-label" for="customRadioInline1">ON</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline2" name="secure_download" class="custom-control-input">
                <label class="custom-control-label" for="customRadioInline2">OFF</label>
              </div>
            </div>
          </div> -->
          <!-- <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Download Listing Type</b></label>
            <div class="col-sm-6">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline1" name="listing_type" v-model="form.listing_type" value="GRID" @change="listingType($event)"  class="custom-control-input" >
                <label class="custom-control-label" for="customRadioInline1">GRID</label>
              </div>

              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioInline2" name="listing_type"  v-model="form.listing_type" value="TABLE" @change="listingType($event)"  class="custom-control-input" >
                <label class="custom-control-label" for="customRadioInline2">TABLE</label>
              </div>
            </div>
          </div> -->
          
          <!-- <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Membership Status</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" v-if="account.subscription_active  && account.subscription_willrenew == 1"  value="Automatic Extension">
              <input type="text" readonly class="form-control form-control-lg" v-else value="No Automatic Extension">
            </div>
            <div class="col-sm-3  text-center text-md-left">
       
                <a  v-if="account.subscription_active" class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0"  href="/managefastspring">Manage Membership</a>
    
                <button v-else class="btn btn-secondary w-100 --style-xsmall mt-3 mt-md-0" disabled="">Manage Membership</button>


            </div>
            
          </div> -->

          <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>Membership</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" v-if="account.subscription_active  && account.subscription_willrenew == 0" :value="`Expires ${premiumExpiry} - will not renew automatically!`">
              <input type="text" readonly class="form-control form-control-lg" v-else-if="account.subscription_active  && account.subscription_willrenew == 1" :value="`Active - renews automatically on ${premiumExpiry}`">
              <input type="text" readonly class="form-control form-control-lg" v-else-if="account.premium_until  && account.premium_until < 2145916800" :value="`Expires ${premiumExpiry} - will not renew automatically!`">
              <input type="text" readonly class="form-control form-control-lg" v-else-if="account.premium_until && account.premium_until >= 2145916800" value="Inactive - Get membership to enable downloads">
              <input type="text" readonly class="form-control form-control-lg" v-else value="Inactive - Get membership to enable downloads">
            </div>
            <div class="col-sm-3  text-center text-md-left">
                <a  v-if="account.subscription_active" class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0"  href="/managefastspring">Manage Membership</a>
                
                <a  v-else class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0"  href="/premium">Buy Membership</a>
            </div>
            
          </div>
          <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>API Key</b></label>
            <div class="col-sm-6">
              <input type="text" readonly class="form-control form-control-lg" :value="account.apikey">
            </div>
            <div class="col-sm-3 text-center text-md-left">
              <a class="btn --theme-primary w-100 --style-xsmall mt-3 mt-md-0" data-toggle="modal" data-target="#renewApiModal">Renew Api Key</a>
            </div>
          </div>
          <div class="form-group row align-items-center">
             <label class="col-sm-3 col-form-label"><b>CDN</b></label>
            <div class="col-sm-6">
              <select class="custom-select custom-select-lg mb-3"  v-model="form.cdn"  @change="downloadServer($event)">
                <option v-for="(cdn, key) in JSON.parse(cdn_list)" :value="key" :key="key" :selected="account.cdn == key">{{ cdn }}</option>
               
              </select>
            </div>
            
          </div>
        </form>

       <!--  MODALS -->

      <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Change Password</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="changePassword($event)">
              <div class="modal-body">
               
                <div class="form-group">
                  <label>New Password</label>
                  <input type="password" class="form-control form-control-lg" v-model="form.new_password" required>
                </div>
                 <p class="text-muted">Please pick a secure password which is not based on dictionary word.</p>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn --theme-primary --style-small" id="change_password_btn">Save changes</button>
                <button type="button" class="btn --theme-blue --style-small" data-dismiss="modal">Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal fade" id="changeEmailModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Change Email Address</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="changeEmail($event)">
              <div class="modal-body">
               
                <div class="form-group">
                  <label>New Email</label>
                  <input type="email" class="form-control form-control-lg" v-model="form.new_email" required>
                </div>
               
                <p class="text-muted">For security reasons we will send a request to your current E-Mail address first. Please contact us, if you have lost access to it.</p>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn --theme-primary --style-small" id="change_email_btn">Save changes</button>
                <button type="button" class="btn --theme-blue --style-small" data-dismiss="modal">Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal fade" id="renewApiModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Renew API Key</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="renewApiKey($event)">
              <div class="modal-body">
                <p>This will change your API Key. The old API Key will stop working and you have to add the new one to your connected Tools and Apps.</p>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn --theme-primary --style-small" id="renew_api_btn">Generate New</button>
                <button type="button" class="btn --theme-blue --style-small" data-dismiss="modal">Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>
       
      </div>
    </div>
  </div>
</template>
 
<script>

  import dayjs from 'dayjs';
  import advancedFormat from 'dayjs/plugin/advancedFormat'

  export default {
      props: ['data','cdn_list','premium','success','error'],
      data() {
          return {
            account: JSON.parse(this.data),
            form: {listing_type: null, cdn: null },
            listing_type: null
          }
      },
      computed: {
        premiumExpiry: function () {
          dayjs.extend(advancedFormat);
          return this.account.premium_until != null ? dayjs(this.account.subscription_periodend,).format('Do MMM YYYY') : null;
        }
      },
      mounted() {
        this.account.apikey = this.account.apikey;
        this.form.cdn = this.account.cdn;


        if(!localStorage.listing_type){
          this.form.listing_type = 'GRID';
        } else if(localStorage.listing_type && localStorage.listing_type == 'GRID'){
          this.form.listing_type = 'GRID';
        } else {
          this.form.listing_type = 'TABLE';
        }

        if(this.success != false ){
          flash(this.success, 'success');
        }

        if(this.error != false){
           flash(this.error, 'error');
        }

        console.log(this.success,this.error);

      },
      methods: {
        changePassword(e){

          $('#change_password_btn').prop('disabled', true);

          axios.post('/account',{action : 'change_password', new_password: this.form.new_password}).then(response=>{
            
            $('#change_password_btn').prop('disabled', false);

            if(response.data.status == 'success'){

              $('#changePasswordModal').modal('hide');
              flash(response.data.message, 'success');

            } 

          }).catch(error=>{

            $('#change_password_btn').prop('disabled', false);

            $('#changePasswordModal').modal('hide');

            flash(JSON.parse(error.request.response).message, 'error');  
          });

        },
        changeEmail(e){

          $('#change_email_btn').prop('disabled', true);

          axios.post('/account',{action : 'change_email', new_email: this.form.new_email}).then(response=>{
            
            $('#change_email_btn').prop('disabled', false);

            if(response.data.status == 'success'){

              $('#changeEmailModal').modal('hide');
              flash(response.data.message, 'success');

            } 

          }).catch(error=>{

            $('#change_email_btn').prop('disabled', false);

            $('#changeEmailModal').modal('hide');

            flash(JSON.parse(error.request.response).message, 'error');  
          });

        },
        renewApiKey(){

          $('#renew_api_btn').prop('disabled', true);

          axios.post('/account',{action : 'renew_api_key', new_email: this.form.new_email}).then(response=>{
            
            $('#renew_api_btn').prop('disabled', false);

            if(response.data.status == 'success'){

              this.account.apikey = response.data.apikey;

              $('#renewApiModal').modal('hide');
              flash(response.data.message, 'success');

            } 

          }).catch(error=>{

            $('#renew_api_btn').prop('disabled', false);

            $('#changeEmailModal').modal('hide');

            flash(JSON.parse(error.request.response).message, 'error');  
          });

        },
        listingType(){

          if(this.form.listing_type == 'GRID' ){
            localStorage.listing_type = 'GRID';
            flash('Download Listing Type Updated!', 'success');
          } else {
            localStorage.listing_type = 'TABLE';
            flash('Download Listing Type Updated!', 'success');
          }
          
        },
        downloadServer(e){

          axios.post('/account',{action : 'change_cdn', new_cdn: this.form.cdn}).then(response=>{

            if(response.data.status == 'success'){
              flash(response.data.message, 'success');
            } 

          }).catch(error=>{

            flash(JSON.parse(error.request.response).message, 'error');  
          });
          
        }
      }
  }
</script>